export var NodeSection = /*#__PURE__*/function (NodeSection) {
  NodeSection["CHILDREN"] = "children";
  NodeSection["ACTIVE"] = "active";
  NodeSection["PROPS"] = "props";
  NodeSection["STYLES"] = "styles";
  return NodeSection;
}({});